import React from 'react';
import { useCompanyContext } from '../../contexts/Company';
import { formatDateForDisplay, formatNumber } from '../../utils';
import moment from 'moment';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogHeader from '../BuildingBlocks/Dialogs/DialogStyleOne/DialogHeader';
import DialogContent from '../BuildingBlocks/Dialogs/DialogStyleOne/DialogContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  dialogBody: { padding: theme.spacing(2), minHeight: 400 },
  mainContent: { textAlign: 'left' },
  bold: { fontWeight: 'bold' },
  button: { fontSize: '1.2em', marginBottom: theme.spacing(2) },
}));

export default function ContractAddendum({
  open,
  handleClose,
  loanTotal,
  loanRepayments,
  linesInChangeRequest,
  planCreateDate,
  originPlanCreateDate,
  onSuccess,
}) {
  const classes = useStyles();
  const today = formatDateForDisplay(moment(), false);
  const { business } = useCompanyContext();

  async function handleSuccess() {
    let text = '';
    const paragraphs = [
      header,
      p1,
      p2,
      businessName,
      p2PartTwo,
      originPlanCreateDateText,
      p2PartThree,
      p3,
      p4,
      planCreateDateText,
      p4PartTwo,
      p5,
      p6,
      loanRepaymentsText,
      p6PartTwo,
      loanTotalText,
      p6PartThree,
      p7,
    ];
    paragraphs.forEach((p) => (text += p + '/n'));
    handleClose();
    onSuccess(
      text,
      linesInChangeRequest?.map((line) => {
        return line?.id;
      }),
    );
  }

  const header =
    'FINANCING OFFER AND ADDENDUM TO MASTER FUTURE REVENUE PURCHASE AGREEMENT';

  const p1 = `Date: ${today}`;
  const p2 = `
      This Offer is made pursuant to the Master Future Revenue Purchase
      Agreement (the “Agreement”) by and between 8fig Inc., a Delaware
      corporation (“Purchaser”) and `;

  const businessName = business?.name;

  const p2PartTwo = ` (“Merchant”) dated as of `;

  const originPlanCreateDateText = formatDateForDisplay(
    originPlanCreateDate,
    false,
  );

  const p2PartThree = `. If accepted by
      Merchant, the Offer will constitute an Addendum to the Agreement, with the
      Agreement and all prior Addenda remaining in full force and effect except
      as specifically modified by this Offer.`;

  const p3 = `Capitalized terms in this Offer are defined in the Agreement.`;

  const p4 = `
      Merchant submitted a Growth Plan on `;

  const planCreateDateText = `${formatDateForDisplay(planCreateDate, false)}`;

  const p4PartTwo = `, adding or editing
      the following Lines (the “New Lines”):`;

  const p5 = `
      ${linesInChangeRequest?.map((line) => `${line.name},`)}
    `;

  const p6 = `
      Based on the Growth Plan, Purchaser hereby offers to purchase `;

  const loanRepaymentsText = `$${formatNumber(loanRepayments)}`;

  const p6PartTwo = ` of Merchant’s revenue from future
      sales of the inventory specified in the New Lines in exchange for
      `;

  const loanTotalText = `$${formatNumber(loanTotal)}`;

  const p6PartThree = `. This purchase will be governed by the
      terms and conditions of the Agreement. If this Offer is accepted by
      Merchant, Merchant’s new Remittance Schedule will be that set forth in
      Exhibit A.`;

  const p7 = `
      By clicking Activate Plan below, Merchant hereby accepts the terms of this
      Offer and agrees that the Agreement and all prior Addenda remain in full
      force and effect.
   `;

  return (
    <Dialog open={open} scroll={'paper'} onClose={handleClose}>
      <div className={classes.dialogBody}>
        <DialogHeader title={header}></DialogHeader>
        <DialogContent>
          <Typography paragraph className={classes.bold}>
            {p1}
          </Typography>
          <div className={classes.mainContent}>
            <Typography paragraph>
              {p2}
              <span className={classes.bold}>{businessName}</span>
              {p2PartTwo}
              <span className={classes.bold}>{originPlanCreateDateText}</span>
              {p2PartThree}
            </Typography>
            <Typography paragraph>{p3}</Typography>
            <Typography>
              {p4} <span className={classes.bold}>{planCreateDateText}</span>
              {p4PartTwo}
            </Typography>
            <ul>
              {linesInChangeRequest?.map((line) => (
                <Typography key={line.id}>
                  <li>
                    <b>{line.name}</b>
                  </li>
                </Typography>
              ))}
            </ul>
            <Typography paragraph>
              {p6} <span className={classes.bold}>{loanRepaymentsText}</span>
              {p6PartTwo}
              <span className={classes.bold}>{loanTotalText}</span>
              {p6PartThree}
            </Typography>
            <Typography paragraph>{p7}</Typography>
          </div>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={handleSuccess}
          >
            Activate Plan
          </Button>
        </DialogContent>
      </div>
    </Dialog>
  );
}
